import { DropdownLayout } from '../components';
import type { StyleProps } from './types';

export function Style19({ items, onClick }: StyleProps) {
  return (
    <DropdownLayout
      items={items}
      activeItemNameKey="codeName"
      activeItemIconName="planet"
      onClick={onClick}
    />
  );
}
